import { pulseAxiosInstance } from "@pulse/api/axiosInstance";

export type ParticipantCount = { total: number; answered: number };
export const getParticipantCount = async ({
    surveyId,
}: {
    surveyId: number;
}): Promise<ParticipantCount> =>
    (await pulseAxiosInstance.get(`participants/survey/${surveyId}/count`)).data;

export const getParticipantByTemporaryUuid = async ({
    temporaryUuid,
}: {
    temporaryUuid: string;
}): Promise<Participant> => (await pulseAxiosInstance.get(`participants/${temporaryUuid}`)).data;

export const bulkParticipants = async ({
    surveyId,
    data,
}: {
    surveyId: number;
    data: BulkParticipantsRequest[];
}): Promise<Participant[]> =>
    (await pulseAxiosInstance.post(`participants/bulk/${surveyId}`, data)).data;

export const getParticipants = ({ surveyId }: { surveyId: number }): Promise<SafeParticipant[]> =>
    pulseAxiosInstance.get(`participants/survey/${surveyId}`).then((res) => res.data);

type InternalParticipantRequest = {
    userId: number;
};

type ExternalParticipantRequest = {
    email: string;
};

export type BulkParticipantsRequest = InternalParticipantRequest | ExternalParticipantRequest;

export type InternalParticipant = {
    userId: number;
    isExternal: false;
};

export type ExternalParticipant = {
    email: string;
    isExternal: true;
};

export type BulkParticipant = InternalParticipant | ExternalParticipant;

export type Participant = {
    id: number;
    temporaryUuid: string;
    surveyId: number;
    answered: boolean;
    userId: number | null;
    email: string | null;
};

export type SafeParticipant = {
    id: number;
    surveyId: number;
    userId: number | null;
    email: string | null;
};
